import React from 'react';

import PropTypes from 'prop-types';

import { TOOLTIP_POSITION } from './constants';

const Tooltip = ({
  children,
  className = '',
  content = '',
  position = TOOLTIP_POSITION.TOP
}) => {
  return (
    <hot-tooltip content={content} position={position} class={className}>
      {children}
    </hot-tooltip>
  );
};

Tooltip.TOOLTIP_POSITION = TOOLTIP_POSITION;

Tooltip.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  content: PropTypes.string,
  position: PropTypes.string
};

export default Tooltip;
